import { atom } from 'recoil'
import { PlanetTypes } from 'services'

export const planetsList = atom<PlanetTypes[]>({
  key: 'planetsList',
  default: []
})
